import { Stack, Typography } from '@mui/material';
import type { LoginModalStatus } from '@/interfaces/component/modal.interface';
import ContentsContainer from '@/components/modal/channel/components/ContentsContainer';
import LoginInputs from '@/components/modal/channel/components/LoginInputs';
import theme from '@/app/theme';

const LoginContents = ({
  onChangeIdInput,
  onChangePwInput,
  status,
  customPrimaryText,
  customSecondaryText
}: {
  onChangeIdInput: (e: InputEvent) => void;
  onChangePwInput: (e: InputEvent) => void;
  status: LoginModalStatus;
  customPrimaryText?: string;
  customSecondaryText?: string;
}) => {
  const getChildElements = (_type: LoginModalStatus) => {
    switch (_type) {
      case 'DEFAULT':
      case 'LOGIN_FAIL':
        return <LoginInputs onChangeIdInput={onChangeIdInput} onChangePwInput={onChangePwInput} />;
      case 'LOGIN_PROGRESS':
        return (
          <Typography variant="subtitle2" marginX="auto" color="primary">
            로그인을 시도하는 중입니다.
          </Typography>
        );
      case 'LOGIN_SUCCESS':
        return (
          <Stack gap="8px">
            <Typography variant="subtitle2" marginX="auto" color="primary">
              로그인에 성공했습니다.
            </Typography>
            <Typography variant="subtitle2" marginX="auto" color={theme.palette.gray[600]}>
              답변 등록 중입니다.
              <br />
              등록 후 기존 화면으로 돌아갑니다
            </Typography>
          </Stack>
        );
    }
  };

  return (
    <ContentsContainer
      primaryText={status === 'LOGIN_FAIL' ? '로그인에 실패하였습니다.' : <>{customPrimaryText || 'AI가 생성한 내용을 채널로 복사해서 옮길 필요 없이 바로 답글을 채널에 등록할 수 있습니다.'}</>}
      secondaryText={status === 'LOGIN_FAIL' ? '아이디와 비밀번호를 다시 확인해 주세요.' : customSecondaryText || '채널당 한 번, 병원이 등록된 계정으로 연동이 필요합니다.'}
      isError={status === 'LOGIN_FAIL'}
    >
      {getChildElements(status)}
    </ContentsContainer>
  );
};

export default LoginContents;
